/* DEPRECATED */

import _ from 'lodash';
import React from 'react';
import Icon from './icons/Icon';

export default class ListItem extends React.Component {
    render() {
        let classes = ['ListItem', this.props.className],
            Tag = this.props.tagName || 'li',
            style = Object.assign({}, this.props.style),
            icon,
            next;

        if ((this.props.icon && _.isString(this.props.icon)) || (this.props.altIcon && _.isString(this.props.altIcon))) {
            let iconSize = this.props.iconSize || 50,
                iconStyle = Object.assign({}, this.props.iconStyle);

            if (this.props.iconSmall) {
                iconSize = 25;
                // Object.assign(iconStyle, {
                //     left: 25,
                //     top: 10
                // });
            }

            icon = (
                <div className="iconContainer">
                    <Icon
                        src={this.props.icon || this.props.altIcon}
                        altSrc={this.props.altIcon}
                        size={iconSize}
                        color={this.props.iconColor}
                        style={iconStyle}
                        onClick={this.props.onIconClick}
                    />
                </div>
            );
        } else if (this.props.icon) {
            icon = <div className="iconContainer text-center">{this.props.icon}</div>;
        }

        if (icon) {
            classes.push('hasIcon');
        }

        if (this.props.next) {
            // next = <div className="next"></div>;
            next = <Icon noIconClass="noIconClass" className="next" src="img/next.png" color={_.get(this.props, 'style.color')} />;
            classes.push('hasNext');
        }

        return (
            <Tag className={classes.join(' ')} style={style} onClick={this.props.onClick} {...this.props.tagProps}>
                {icon}
                <div className="content">{this.props.children}</div>
                {next}
                {this.props.toolbar || ''}
            </Tag>
        );
    }
}
